const create = (api) => {
    // This API is used to get the software profile data-table (not numeric data)
    const getProfilesDetailsInfo = (pageNumber=1, pageSize=100, sort='', directionSort='', searchTerm='') => {
        const query = `&query=${searchTerm}` 
        return api.get(`/software-profile?pageSize=${pageSize}&pageNumber=${pageNumber}&directionSort=${directionSort}&sort=${sort}${query}`)
    }

    // This API is used to get the software profile metrics (numeric data)
    const postSoftwareProfileMetrics = (payload=[]) => {
        return api.post(`/software-profile/metrics`, payload)
    }

    //This API get the total metrics by organization (bar chart - profiles)
const getTotalMetricsByOrganization = (searchTerm='') => {
 
    const query = (searchTerm === undefined) || (searchTerm.query==='') ? `?query=` : `?query=${searchTerm.query}` 
        return api.get(`/software-profile/metricstotal${query}`)
    }

    //This API is used to get the software profile details data-table
    const getSoftwareProfileDetails = (profileID='', pageNumber=1, pageSize=100, sort='', directionSort='', searchTerm='', assetStatus='', language='en-US') => {
        const query = `&query=${searchTerm}` 
        return api.get(`/software-profile/${profileID}/details?pageSize=${pageSize}&pageNumber=${pageNumber}&directionSort=${directionSort}&sort=${sort}${query}&assetStatus=${assetStatus}&language=${language}`)
    }

    const getSoftwareProfileDetailsByProfileID = (profileId) => {
        return api.get(`/software-profile/${profileId}`)
    }
    
    // This API is used to export the software profiles data-table
  const postExportSoftwareProfiles = (language = 'en-US', chartName = '', sort = '', directionSort = '', searchTerm = '', id = undefined, assetStatus = '') => {
    const query = `&query=${searchTerm}` 
        const profileId = id === undefined ? `&profileId=` : `&profileId=${id}` 
        return api.post(`/v2/devices/exportfiles?language=${language}&chartName=${chartName}&sort=${sort}&directionSort=${directionSort}${query}${profileId}&assetStatus=${assetStatus}`)
    }

    // This API is used to change the software profile status
    const putSoftwareProfileStatus = (profileId, organizationId, newStatus) => {
        return api.put(`/software-profile/${profileId}/status?organizationId=${organizationId}&status=${newStatus}`);
    }

     // This API is used to get the packages details once a device type and models are selected
    const getPackagesDetails = (deviceTypeSelected="mobilecomputer", deviceModelSelected=[], pageNumber=1, pageSize=100, payload={}) => {
        return api.post(`/v3/packages?filter={"CompatibleDeviceType":"${deviceTypeSelected}","CompatibleDeviceModels":{"$in":${deviceModelSelected}},"properties.intersectModels":"true"}&pageNumber=${pageNumber}&pageSize=${pageSize}`, payload)
    }

    //This API is used to get sites details (organizations)
    const getSitesDetails = (pageNumber=1, pageSize=100) => {
        return api.get(`/groupmgmt/OrgUnits/v2/administrable?pageNumber=${pageNumber}&pageSize=${pageSize}`)
    }

    // This API is used to create a new software profile
    const postCreateSoftwareProfile = (payload={}) => { 
        return api.post(`/software-profile`, payload)
    }

    // This API is used to edit a software profile
    const putSoftwareProfile = (payload={}) => {
        return api.put(`/software-profile`, payload)
    }

    // This API checks for assignment conflicts of profiles to models in the selected sites
    const postCheckProfileAssignmentConflicts = (payload = {}) => {
        return api.post(`/software-profile/sitemodels`, payload)
    }

    return {
        getSitesDetails,
        getPackagesDetails,
        getProfilesDetailsInfo,
        putSoftwareProfileStatus,
        getTotalMetricsByOrganization,
        getSoftwareProfileDetails,
        postSoftwareProfileMetrics,
        getSoftwareProfileDetailsByProfileID,
        postCreateSoftwareProfile,
        putSoftwareProfile,
        postExportSoftwareProfiles,
        postCheckProfileAssignmentConflicts
    }
}

export default {
    create
}
